import React from "react";
import { Grid, Typography } from "@mui/material";
import {
  AboutMeSectionContainer,
  AboutMeTitleWrap,
  AboutMeTextWrap,
  ImageWrap,
  ImgGrid,
  aboutStylesText,
  aboutTitleTypo,
} from "./styledAboutMe";

import AboutMeTabs from "./AboutMeTabs";

function AboutMeSection() {
  return (
    <AboutMeSectionContainer container justifyContent="center" id="about">
      <Grid container item justifyContent="space-evenly" alignItems="center">
        <Grid container item xs={10} md={10} justifyContent="center">
          <ImageWrap
            container
            justifyContent="center"
            alignItems="center"
            item
            xs={12}
            md={6}
          >
            <ImgGrid />
          </ImageWrap>
          <Grid
            container
            item
            xs={10}
            md={6}
            justifyContent="center"
            alignItems="center"
          >
            <AboutMeTitleWrap container item xs={4} md={12}>
              <Typography sx={aboutTitleTypo}> About Me </Typography>
            </AboutMeTitleWrap>
            <AboutMeTextWrap container item xs={12}>
              <Typography sx={aboutStylesText}>
                Practical Software Engineer, able to adapt in both self-starting
                and collaborative environments while staying focused on
                achieving high-quality results. Eager to tackle web development
                challenges in order to expend my knowledge.
              </Typography>
            </AboutMeTextWrap>
              <AboutMeTabs />
            {/* </Grid> */}
          </Grid>
        </Grid>
      </Grid>
    </AboutMeSectionContainer>
  );
}

export default AboutMeSection;
